import React from 'react'

export const H1 = ({ title, style }) => (<div style={{ fontSize: "22px", color: "#001529", marginTop: '20px', ...style }} >{title}</div>)
